import { CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

const TabsHeader = () => {
  return (
    <CardHeader className="px-3">
      <CardTitle className="text-xl font-semibold text-indigo-900 text-right">ניהול מערכת</CardTitle>
      <CardDescription className="text-right text-slate-600">בחר את האזור שברצונך לנהל</CardDescription>
    </CardHeader>
  );
};

export default TabsHeader;
